import { Component, DestroyRef, OnInit } from '@angular/core';
import { DashboardTileModal } from './dashboard.model';
import { dashboardTileList, publicDashboardConfig } from './dashboard.config';
import { SharedModule } from 'src/app/shared/shared.module';
import { SvgIconComponent } from '../../../shared/components/svg-icon/svg-icon.component';
import { Router } from '@angular/router';
import {
  DashboardActionButtonNames,
  pageUrls,
} from 'src/app/shared/utility/constants';
import { AuthService } from '../../../shared/services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [SharedModule, SvgIconComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  public tiles: DashboardTileModal[] = [];

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.authService.isLoggedIn$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isLoggedIn => {
        this.tiles = isLoggedIn ? dashboardTileList : publicDashboardConfig;
      });
  }

  onTileBtnCick(actionBtnName: string) {
    if (actionBtnName === DashboardActionButtonNames.contactSales) {
      this.router.navigate(['/contact-sales']);
    } else if (actionBtnName === DashboardActionButtonNames.shipmentTracking) {
      this.router.navigate([pageUrls.shipmentTrackFormPage]);
    } else if (actionBtnName === DashboardActionButtonNames.trackManifest) {
      this.router.navigate([pageUrls.trackManifest]);
    } else if (actionBtnName === DashboardActionButtonNames.manifestUpload) {
      this.router.navigate([pageUrls.manifestUpload]);
    } else if (actionBtnName === DashboardActionButtonNames.genAirWaybill) {
      this.router.navigate([pageUrls.genAirWaybill]);
    } else if (actionBtnName === DashboardActionButtonNames.aamsDocuments) {
      this.router.navigate([pageUrls.aamsDocuments]);
    } else if (actionBtnName === DashboardActionButtonNames.apiDocumentation) {
      this.router.navigate([pageUrls.apiDocumentation]);
    }
  }
}
